import * as React from 'react';
import styled from 'styled-components';
import { themeGet, is } from '@packages/ui';

const primaryColor = themeGet.colors('primary');

const MainNavItemStyled = styled.li<{
  emphesize: boolean;
  isActive: boolean;
  isCurrent: boolean;
}>`
  list-style: none;
  font-size: ${themeGet.fontSize(6)};
  padding: 12px ${themeGet.space(2)};
  > a {
    transition: all 200ms linear;
    border-bottom: 2px solid transparent;
    display: inline-block;
    color: ${themeGet.colors('kilamanjaro')};
    &:hover {
      color: ${primaryColor};
    }
    ${is('emphesize')`
      color: ${primaryColor};
      text-transform: uppercase;
    `};
    ${is('isActive')`
      border-bottom: 2px solid ${primaryColor};
    `};
    ${is('isCurrent')`
      border-bottom: 2px solid ${themeGet.colors('primaryDark')};
    `};
  }
`;

export interface LinkItemProps {
  emphesize?: boolean;
  isCurrent?: boolean;
  isActive?: boolean;
  onHover?: (event: React.MouseEvent) => void;
  onTouch?: (event: React.TouchEvent) => void;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

export const LinkItem: React.FC<LinkItemProps> = ({
  children,
  emphesize = false,
  isCurrent = false,
  isActive = false,
  onHover,
  onTouch,
  onClick,
  className,
}) => {
  return (
    <MainNavItemStyled
      className={className}
      onClick={onClick}
      onMouseOver={onHover}
      emphesize={emphesize}
      isCurrent={isCurrent}
      isActive={isActive}
      onTouchStart={onTouch}
    >
      {children}
    </MainNavItemStyled>
  );
};
